import React from 'react';
import styled from 'styled-components';

const NewsPage = () => {
  return (
    <NewsContainer>
      {/* Titre de la page */}
      <BackgroundText> Actualités </BackgroundText>

      {/* Section principale avec le texte */}
      <NewsContent>
        <MainText>
          <span>Les dernières</span>
          <span>innovations et</span>
          <span>avancées de</span>
          <span>VoltAuto</span>
        </MainText>

        {/* Ligne de séparation */}
        <TopLine>
          <Line />
        </TopLine>

        {/* Sous-titre */}
        <SubHeader>
          Explorez les dernières actualités de notre entreprise et de notre secteur
        </SubHeader>

        {/* Liste des actualités */}
        <NewsList>
          <NewsCard>
            <CardContent>
              <CardTitle>Nouveau partenariat avec une entreprise technologique</CardTitle>
              <CardDate>15 Décembre 2024</CardDate>
              <CardExcerpt>
                Nous avons annoncé un partenariat stratégique avec une entreprise leader dans les technologies avancées, accélérant l'innovation dans les véhicules électriques...
              </CardExcerpt>
            </CardContent>
          </NewsCard>

          <NewsCard>
            <CardContent>
              <CardTitle>Lancement du projet VOLTAUTO X Series</CardTitle>
              <CardDate>1 Décembre 2024</CardDate>
              <CardExcerpt>
                Le lancement officiel du VOLTAUTO X Series marque une étape clé dans notre vision de la mobilité durable, transformant l'industrie automobile...
              </CardExcerpt>
            </CardContent>
          </NewsCard>

          <NewsCard>
            <CardContent>
              <CardTitle>Innovation dans les moteurs électriques</CardTitle>
              <CardDate>20 Novembre 2024</CardDate>
              <CardExcerpt>
                Nous dévoilons un moteur électrique innovant, conçu pour maximiser l'efficacité énergétique tout en réduisant l'empreinte écologique...
              </CardExcerpt>
            </CardContent>
          </NewsCard>
        </NewsList>
      </NewsContent>
    </NewsContainer>
  );
};

export default NewsPage;

const NewsContainer = styled.div`
  min-height: 100vh;
  width: 100%;
  color: rgba(0, 0, 0, 0.8);
  overflow: hidden;
  background: #f0f0f0;

  @media (max-width: 1024px) {
    justify-content: center;
    align-items: center;
  }
`;

const NewsContent = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 4rem;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;

  @media (max-width: 1700px) {
    padding: 2rem;
    align-items: flex-start;
  }
`;

const MainText = styled.h1`
  position: relative;
  font-size: clamp(3rem, 8vw, 6.5rem);
  line-height: 1;
  font-weight: 500;
  text-align: right;
  margin: 0;
  max-width: 800px;
  padding-top: 10vh;
  left: 60%;

  span {
    display: block;
    margin-bottom: 0.2em;
    opacity: 0;
    animation: fadeInUp 0.8s ease forwards;

    @for $i from 1 through 4 {
      &:nth-child(#{$i}) {
        animation-delay: #{$i * 0.2}s;
      }
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 1700px) {
    left: 0;
  }

  @media (max-width: 1024px) {
    max-width: 600px;
    left: 0;
  }

  @media (max-width: 768px) {
    text-align: left;
    padding-top: 5vh;
    left: 0;
  }
`;

const BackgroundText = styled.div`
  position: fixed;
  transform: translate(-50%, -50%);
  font-size: 25px;
  font-weight: 1000;
  color: rgba(0, 0, 0, 0.4);
  white-space: nowrap;
  pointer-events: none;
  z-index: 1;
  user-select: none;
  text-transform: uppercase;
  letter-spacing: 0.5vw;
  opacity: 0.5;
  top: 10%;
  left: 20vh;

  @media (max-width: 768px) {
    left: 10vh;
    top: 5vh;
    font-size: 25px;
    max-width: 100%;
  }
`;

const TopLine = styled.div`
  width: 100%;
  padding: 0;
  margin-top: 10%;

  @media (max-width: 768px) {
    margin: 1rem 0 3rem;
  }
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  background: gray;
`;

const SubHeader = styled.h2`
  font-size: clamp(1rem, 1.5vw, 1.2rem);
  color: #999;
  font-weight: 400;
  text-align: left;
  margin: 15vh 0 5vh;
  max-width: 800px;

  @media (max-width: 768px) {
    text-align: left;
    margin: 10vh 0 5vh;
    max-width: 100%;
  }
`;

const NewsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-top: 5vh;
`;

const NewsCard = styled.div`
  background-color: #fff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const CardTitle = styled.h3`
  font-size: clamp(1.5rem, 2.5vw, 2rem);
  font-weight: 700;
  margin: 0;
`;

const CardDate = styled.p`
  font-size: clamp(1rem, 2vw, 1.2rem);
  color: #999;
  margin: 0;
`;

const CardExcerpt = styled.p`
  font-size: clamp(1rem, 2vw, 1.2rem);
  color: #555;
  line-height: 1.5;
`;
